// Social Media Image Templates
const imageTemplates = [
  { 
    id: 'social-quote', 
    name: 'Quote Post', 
    category: 'Professional',
    thumbnail: '/images/templates/quote-post.png',
    template: {
      name: 'Quote Post',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: '#1A1A1A',
            draggable: false,
          },
          {
            id: 'quote-mark',
            type: 'heading',
            text: '"',
            x: 540,
            y: 200,
            width: 200,
            fontSize: 150,
            fontFamily: 'Georgia',
            fontWeight: '700',
            fill: '#FFFFFF',
            opacity: 0.2,
            draggable: true,
            align: 'center'
          },
          {
            id: 'quote-text',
            type: 'paragraph',
            text: 'Your inspiring quote goes here. Make it meaningful and impactful.',
            x: 540,
            y: 500,
            fontSize: 48,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#FFFFFF',
            width: 800,
            draggable: true,
            lineHeight: 1.4,
            align: 'center'
          },
          {
            id: 'author',
            type: 'heading',
            text: '- Your Name',
            x: 540,
            y: 800,
            width: 400,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#FFFFFF',
            draggable: true,
            align: 'center'
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#1A1A1A'
      }
    }
  },
  { 
    id: 'tips-template', 
    name: 'Tips & Tricks', 
    category: 'Professional',
    thumbnail: '/images/templates/tips-tricks.png',
    template: {
      name: 'Tips & Tricks',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: '#FFFFFF',
            draggable: false,
          },
          {
            id: 'accent-rect',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 200,
            fill: '#FF6B6B',
            draggable: false,
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: '5 TIPS FOR SUCCESS',
            x: 540,
            y: 100,
            fontSize: 64,
            fontFamily: 'Montserrat',
            fontWeight: '700',
            fill: '#FFFFFF',
            draggable: true,
            align: 'center'
          },
          {
            id: 'tips-text',
            type: 'paragraph',
            text: '1. Start Early\n2. Stay Focused\n3. Learn Daily\n4. Network Often\n5. Take Action',
            x: 540,
            y: 500,
            fontSize: 40,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#333333',
            width: 800,
            draggable: true,
            lineHeight: 2,
            align: 'center'
          },
          {
            id: 'footer-text',
            type: 'paragraph',
            text: 'Follow for more tips!',
            x: 540,
            y: 950,
            width: 400,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#FF6B6B',
            draggable: true,
            align: 'center'
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#FFFFFF'
      }
    }
  },
  {
    id: 'carousel-cover',
    name: 'Carousel Cover',
    category: 'Creative',
    thumbnail: '/images/templates/carousel-cover.png',
    template: {
      name: 'Carousel Cover',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: '#F8F9FA',
            draggable: false,
          },
          {
            id: 'accent-circle',
            type: 'circle',
            x: 540,
            y: 540,
            radius: 400,
            fill: '#4A90E2',
            opacity: 0.1,
            draggable: false,
          },
          {
            id: 'main-heading',
            type: 'heading',
            text: 'Complete Guide:',
            x: 540,
            y: 400,
            fontSize: 72,
            fontFamily: 'Poppins',
            fontWeight: '700',
            fill: '#2C3E50',
            draggable: true,
            align: 'center'
          },
          {
            id: 'sub-heading',
            type: 'heading',
            text: 'Social Media Strategy',
            x: 540,
            y: 500,
            fontSize: 48,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#4A90E2',
            draggable: true,
            align: 'center'
          },
          {
            id: 'swipe-text',
            type: 'paragraph',
            text: 'Swipe for more →',
            x: 540,
            y: 900,
            width: 400,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#6C757D',
            draggable: true,
            align: 'center'
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#F8F9FA'
      }
    }
  },
  {
    id: 'testimonial-card',
    name: 'Testimonial Card',
    category: 'Professional',
    thumbnail: '/images/templates/testimonial.png',
    template: {
      name: 'Testimonial Card',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: '#1E293B',
            draggable: false
          },
          {
            id: 'accent-circle',
            type: 'circle',
            x: 540,
            y: 540,
            radius: 400,
            fill: '#3B82F6',
            opacity: 0.1,
            draggable: false
          },
          {
            id: 'quote-mark',
            type: 'heading',
            text: '"',
            x: 540,
            y: 160,
            width: 200,
            fontSize: 120,
            fontFamily: 'Georgia',
            fontWeight: '700',
            fill: '#3B82F6',
            opacity: 0.4,
            draggable: true,
            align: 'center'
          },
          {
            id: 'testimonial-text',
            type: 'paragraph',
            text: 'The results have been incredible. Our engagement has increased by 150% since implementing these strategies!',
            x: 540,
            y: 400,
            fontSize: 40,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#FFFFFF',
            width: 800,
            draggable: true,
            lineHeight: 1.6,
            align: 'center'
          },
          {
            id: 'client-name',
            type: 'paragraph',
            text: 'John Smith',
            x: 540,
            y: 700,
            width: 400,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#3B82F6',
            draggable: true,
            align: 'center'
          },
          {
            id: 'client-title',
            type: 'paragraph',
            text: 'Marketing Director',
            x: 540,
            y: 750,
            width: 400,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#94A3B8',
            draggable: true,
            align: 'center'
          },
          {
            id: 'rating',
            type: 'paragraph',
            text: '⭐⭐⭐⭐⭐',
            x: 540,
            y: 850,
            width: 400,
            fontSize: 40,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#FCD34D',
            draggable: true,
            align: 'center'
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#1E293B'
      }
    }
  },
  {
    id: 'stat-highlight',
    name: 'Statistic Highlight',
    category: 'Corporate',
    thumbnail: '/images/templates/statistics.png',
    template: {
      name: 'Statistic Highlight',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: '#F8FAFC',
            draggable: false
          },
          {
            id: 'accent-line-1',
            type: 'line',
            x: 100,
            y: 100,
            points: [0, 0, 880, 0],
            stroke: '#0EA5E9',
            strokeWidth: 4,
            draggable: false
          },
          {
            id: 'stat-number',
            type: 'heading',
            text: '250%',
            x: 540,
            y: 400,
            fontSize: 120,
            fontFamily: 'Poppins',
            fontWeight: '700',
            fill: '#0EA5E9',
            draggable: true,
            align: 'center'
          },
          {
            id: 'stat-label',
            type: 'heading',
            text: 'Growth in Q4',
            x: 540,
            y: 560,
            fontSize: 48,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#0F172A',
            draggable: true,
            align: 'center'
          },
          {
            id: 'stat-description',
            type: 'paragraph',
            text: 'Year-over-year increase in user engagement',
            x: 540,
            y: 650,
            width: 600,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#64748B',
            draggable: true,
            align: 'center'
          },
          {
            id: 'accent-line-2',
            type: 'line',
            x: 100,
            y: 900,
            points: [0, 0, 880, 0],
            stroke: '#0EA5E9',
            strokeWidth: 4,
            draggable: false
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#F8FAFC'
      }
    }
  },
  {
    id: 'feature-announcement',
    name: 'Feature Launch',
    category: 'Creative',
    thumbnail: '/images/templates/feature-launch.png',
    template: {
      name: 'Feature Launch',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-gradient',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: '#4F46E5',
            draggable: false
          },
          {
            id: 'accent-circle-1',
            type: 'circle',
            x: 840,
            y: 240,
            radius: 200,
            fill: '#818CF8',
            opacity: 0.3,
            draggable: false
          },
          {
            id: 'accent-circle-2',
            type: 'circle',
            x: 240,
            y: 840,
            radius: 160,
            fill: '#C7D2FE',
            opacity: 0.3,
            draggable: false
          },
          {
            id: 'new-label',
            type: 'paragraph',
            text: '✨ NEW FEATURE',
            x: 540,
            y: 200,
            width: 400,
            fontSize: 28,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#C7D2FE',
            draggable: true,
            align: 'center'
          },
          {
            id: 'feature-name',
            type: 'heading',
            text: 'AI-Powered Analytics',
            x: 540,
            y: 400,
            fontSize: 72,
            fontFamily: 'Poppins',
            fontWeight: '700',
            fill: '#FFFFFF',
            draggable: true,
            align: 'center'
          },
          {
            id: 'feature-description',
            type: 'paragraph',
            text: 'Transform your data into actionable insights with our new AI analytics dashboard',
            x: 540,
            y: 600,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#E0E7FF',
            width: 800,
            draggable: true,
            lineHeight: 1.4,
            align: 'center'
          },
          {
            id: 'cta-text',
            type: 'paragraph',
            text: 'Get Early Access →',
            x: 540,
            y: 800,
            width: 400,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#C7D2FE',
            draggable: true,
            align: 'center'
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        background: '#4F46E5'
      }
    }
  },
  {
    id: 'pricing-quote',
    name: 'Pricing Quote',
    category: 'Professional',
    thumbnail: '/images/templates/pricing-quote.png',
    template: {
      name: 'Pricing Quote',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          // Background gradient
          {
            id: 'bg-rect',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1080,
            height: 1080,
            fill: {
              type: 'linear',
              coords: {
                x1: 0,
                y1: 0,
                x2: 1080,
                y2: 1080
              },
              colorStops: [
                { offset: 0, color: '#1a2e0d' },
                { offset: 1, color: '#000000' }
              ]
            },
            opacity: 1,
            draggable: false,
            selectable: false,
            evented: false
          },
          // Logo/Brand section
          {
            id: 'logo',
            type: 'image-placeholder',
            x: 100,
            y: 50,
            width: 40,
            height: 40,
            label: 'Logo',
            cornerRadius: 8
          },
          {
            id: 'website',
            type: 'paragraph',
            text: 'yourcompany.com',
            x: 540,
            y: 630,
            width: 400,
            fontSize: 28,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#64748B',
            draggable: true,
            align: 'center'
          },
          // Profile section
          {
            id: 'profile-image',
            type: 'image-placeholder',
            x: 100,
            y: 200,
            width: 120,
            height: 120,
            cornerRadius: 60,
            label: 'Profile'
          },
          {
            id: 'name',
            type: 'paragraph',
            text: 'John Doe',
            x: 540,
            y: 720,
            width: 400,
            fontSize: 36,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#1F2937',
            draggable: true,
            align: 'center'
          },
          {
            id: 'handle',
            type: 'paragraph',
            text: '@johndoe',
            x: 540,
            y: 770,
            width: 400,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#6B7280',
            draggable: true,
            align: 'center'
          },
          // Main quote section
          {
            id: 'quote-1',
            type: 'paragraph',
            text: 'A good price\nattracts clients.',
            x: 100,
            y: 400,
            fontSize: 64,
            fontFamily: 'Poppins',
            fontWeight: 'bold',
            fill: '#ffffff',
            width: 800,
            draggable: true,
            lineHeight: 1.2
          },
          {
            id: 'quote-2',
            type: 'paragraph',
            text: 'The right price\nattracts',
            x: 100,
            y: 580,
            fontSize: 64,
            fontFamily: 'Poppins',
            fontWeight: 'bold',
            fill: '#ffffff',
            width: 800,
            draggable: true,
            lineHeight: 1.2
          },
          {
            id: 'quote-highlight',
            type: 'paragraph',
            text: 'productivity increased by 200%',
            x: 540,
            y: 950,
            width: 600,
            fontSize: 32,
            fontFamily: 'Poppins',
            fontWeight: '700',
            fill: '#EF4444',
            draggable: true,
            align: 'center'
          },
          // Footer section
          {
            id: 'footer-left',
            type: 'paragraph',
            text: 'Helping great companies\nwith great design',
            x: 100,
            y: 900,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: 'normal',
            fill: '#ffffff',
            opacity: 0.7,
            width: 400,
            draggable: true,
            lineHeight: 1.4
          },
          {
            id: 'footer-right',
            type: 'paragraph',
            text: 'Agency-level designs\nwithout the agency cost',
            x: 700,
            y: 900,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: 'normal',
            fill: '#ffffff',
            opacity: 0.7,
            width: 400,
            textAlign: 'right',
            draggable: true,
            lineHeight: 1.4
          }
        ]
      }],
      canvasSettings: {
        width: 1080,
        height: 1080,
        backgroundColor: '#1a2e0d'
      }
    }
  }
];

export default imageTemplates; 